import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import type { TypeExchangeItemAddData } from '~/types/claim.types';

/**
 * [교환 신청/조회] 교환 상품 추가 모달 > 테이블 컬럼 정의
 *
 * @note 첫 컬럼은 행 선택(다중) 체크박스만 담는다.
 */
const getClaimExchangeItemsAddColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeExchangeItemAddData>[] = [
    {
      id: 'selection',
      header: '',
      cell: () => null,
      size: 44,
      meta: { selection: true },
    },
    {
      accessorKey: 'skuCode',
      header: '상품코드',
      size: 130,
    },
    {
      accessorKey: 'skuName',
      header: '상품명',
      minSize: 565,
      meta: { flex: true },
    },
  ];

  return { columnDefs };
};

export default getClaimExchangeItemsAddColumnDefs;
